import {useAuth0} from "@auth0/auth0-react";
import React, {useEffect, useState} from "react";
import {PageLayout} from "../../components/page-layout";
import { getCompanies, getCompanyForSiret, saveCompanyInfos } from "../../services/admin.service";
import {useForm} from "react-hook-form";
import { toast } from 'react-toastify';
import { DropdownButton } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";

export const PageCompanyInfos = () => {
    const {getAccessTokenSilently} = useAuth0();

    const {register, handleSubmit, setValue, formState: {errors}} = useForm();
    const onSubmit = data => setCompanyInfos(data);

    const [options, setOptions] = useState([]);

    const setCompanyInfos = async (data) => {
        console.log(data);
        const accessToken = await getAccessTokenSilently();
        saveCompanyInfos(accessToken, siret, data).then((result) => {
            toast.success('Entreprise sauvegardée !');
        });
    }

    function onCompanySelect(event) {
        setValue("siret", event);
        if (event.length === 14) {
            getCompanyInfos(event)
        }
    }

    const [siret, setSiret] = useState("");
    useEffect(() => {
        const formattedSiret = siret.replace(/\s/g, '');
        if (formattedSiret.length == 14) {
            getCompanyInfos(formattedSiret)
        }
    }, [siret]);

    useEffect(() => {
        async function fetchCompanies() {
            const accessToken = await getAccessTokenSilently();
            const { data, error } = await getCompanies(accessToken);
            const results = [];
            // Store results in the results array
            data.forEach((value) => {
                results.push({
                    key: value.second,
                    value: value.first + ' - ' + value.second
                });
            });

            setOptions([
                {key: 'Select a company', value: ''},
                ...results
            ])
        }
        fetchCompanies();
    }, []);

    const getCompanyInfos = async (siret) => {
        console.log("getCompanyInfos", siret);
        const accessToken = await getAccessTokenSilently();
        const {data, error} = await getCompanyForSiret(accessToken, siret);

        console.log("getCompanyInfos", data, error);
        if (data) {
            setValue("siret", data.siret)
            setValue("name", data.name)
            setValue("address1", data.address1)
            setValue("address2", data.address2)
            setValue("postalCode", data.postalCode)
            setValue("city", data.city)
            setValue("colleges", data.colleges)
            setValue("idcc", data.idcc)
            setValue("contactFirstName", data.contactFirstName)
            setValue("contactLastName", data.contactLastName)
            setValue("contactRole", data.contactRole)
            setValue("contactPhone", data.contactPhone)
            setValue("contactEmail", data.contactEmail)
            setValue("lastElection", new Date(data.lastElection).toISOString().substring(0, 10))
            setValue("userId", data.userId)
            toast.success('Entreprise chargée', {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        if (error) {
            //setUserId("")
            // setError(JSON.stringify(error, null, 2));
        }
    }


    return (
        <PageLayout>
            <div className="content-layout">
                <h1 id="page-title" className="content__title">
                    Information entreprises
                </h1>
                <div className="content__body">
                    <p id="page-description">
                    <span>
                        Tapez le numero de SIRET pour compléter les informations de l'entreprise.
                    </span>
                    </p>
                    {
                        <DropdownButton
                          id={`dropdown-variants}`}
                          title='Select existing company'
                          onSelect={onCompanySelect}
                        >
                            {options.map(
                              (variant) => (
                                <Dropdown.Item eventKey={variant.key}>{variant.value}</Dropdown.Item>
                              ))}
                        </DropdownButton>
                    }
                    <div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="">
                                <div className="row">
                                    <div className="column left">
                                        <span>Numero siret: </span>
                                    </div>
                                    <div className="column right">

                                        <input placeholder="Siret (14 chiffres)"
                                               size="14" style={{width: "9em"}}
                                               {...register("siret", {
                                                   required: true,
                                                   minLength: 14,
                                                   maxLength: 14
                                               })}
                                               onChange={(event) => setSiret(event.target.value)}/>
                                        {errors.siret && <p className="error">Siret must 14 characters long</p>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Nom de l'entreprise: </span>
                                    </div>
                                    <div className="column right">
                                        <input {...register("name", {})}
                                               style={{width: "12em"}}
                                               placeholder="nom"/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Addresse : </span>
                                    </div>
                                    <div className="column">
                                        <input {...register("address1", {})}
                                               style={{width: "15em"}}
                                               placeholder="addresse"/>
                                        <div className="row">
                                            <div className="column">
                                            </div>
                                            <div className="column">
                                                <input {...register("address2", {})}
                                                       style={{width: "15em"}}
                                                       placeholder="addresse (suite)"/>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Code Postal et ville : </span>
                                    </div>
                                    <div className="column right">
                                        <input size="5" style={{width: "6em"}}
                                               type="number" {...register("postalCode", {})}
                                               placeholder="code"/>
                                        <input {...register("city", {})}
                                               style={{width: "12em"}}
                                               placeholder="Ville"/>
                                    </div>
                                </div>
                                <p><i>Facultatifs : </i></p>
                                <div className="row">
                                    <div className="column left">
                                        <span>Identifiant convention collective : </span>
                                    </div>
                                    <div className="column right">
                                        <input size="5" style={{width: "6em"}}
                                               {...register("idcc", {})} />
                                        <a href="https://travail-emploi.gouv.fr/dialogue-social/negociation-collective/article/conventions-collectives-nomenclatures" target="new">(référentiel)</a>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Nombre de collèges : </span>
                                    </div>
                                    <div className="column right">
                                        <input size="2" style={{width: "3em"}}
                                               type="number" {...register("colleges", {})} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Contact : </span>
                                    </div>
                                    <div className="column right">
                                            <input
                                                {...register("contactFirstName", {})}
                                                style={{width: "8em"}}
                                                placeholder="Prénom"
                                            />
                                            <input
                                                {...register("contactLastName", {})}
                                                style={{width: "14em"}}
                                                placeholder="Nom"
                                            />
                                        <div className="column right">
                                            <input
                                                {...register("contactRole", {})}
                                                style={{width: "14em"}}
                                                placeholder="rôle"
                                            />
                                            <div className="column right">
                                                <input
                                                    {...register("contactEmail", {})}
                                                    style={{width: "14em"}}
                                                    placeholder="email"
                                                />
                                                <div className="column right">
                                                    <input
                                                        {...register("contactPhone", {})}
                                                        style={{width: "14em"}}
                                                        placeholder="téléphone"
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Dernière élection CSE : </span>
                                    </div>
                                    <div className="column right">
                                        <input type="date" {...register("lastElection", {setValueAsDate: true,})}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="column left">
                                        <span>Id utilisateur : </span>
                                    </div>
                                    <div className="column right">
                                        <input {...register("userId", {})}
                                               placeholder="12345..."
                                        />
                                    </div>
                                </div>
                                <p><input type="submit" className="button button--compact button--primary"/></p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
};
